import { Volume } from "./Volume";
export function MountingTree() {
  const tree = [<Volume index={"root"} key={"root"} />];

  return <div className="mountingTree">{tree}</div>;
}
